import { USER_ROLE, USER_TYPE } from '@/model/user';
import { AbilityBuilder, Ability } from '@casl/ability';
import manageAbility from '@/services/manageAbility';
import witnessAbility from '@/services/witnessAbility';
import ownerAbility from '@/services/ownerAbility';
import adminAbility from '@/services/adminAbility';
import customerAbility from '@/services/customerAbility';

export default function defineAbilityFor(userType = null, roleId: number = null) {
  const { can, cannot, build } = new AbilityBuilder(Ability);
  if (userType) {
    if (userType === USER_TYPE.STAFF) {
      // check role of company
      if (roleId === USER_ROLE.ADMIN) {
        adminAbility(can, cannot);
      } else if (roleId === USER_ROLE.MANAGE) {
        manageAbility(can, cannot);
      } else if (roleId === USER_ROLE.WITNESS) {
        witnessAbility(can, cannot);
      } else {
        ownerAbility(can, cannot);
      }
    } else if (userType === USER_TYPE.CUSTOMER) {
      customerAbility(can);
    }
  }

  return build();
}
